import { Tooltip } from "antd";
import styles from "./gifMessage.module.scss";
import React, { useState } from 'react';
import ChatLike from "../chatLike";
import ChatHoverOption from "../chatHoverOption";
import ChatUserInfo from "../chatUserInfo";
import ChatLeftInfo from "../chatLeftInfo";
import ChatRightInfo from "../chatRightInfo";
import moment from "moment";
import { chats, initialStateModel } from "../../../../models/model";
import { useSelector } from "react-redux";
import { URCheckBoxCall } from "../../../../shared/widgets/checkBoxForCall/callCheckBox";
import store from "../../../../context/store/store";
import { Types } from "../../../../context/action/action";
import _ from "lodash";
import gificon from "../../../../styles/images/gifbtn.svg";
import ForwardHeader from "../forwardHeader";
import ChatGifInfo from "../chatGifInfo";
import FilePreview from "../filePreview";
import { urlify, urlifyATmention } from "../../../../base/utils";
type gifMessageProps = {
  data: any;
  previewopen?: Function;
  multiData?: any;
  searchedData?: any;
  savedData?: any;
  timeValue?: any;
}
type fileMessageState = {
  isOpen: boolean;
  id: any;
  dataRes: any;
};
export default function ChatGifMessage({ data, multiData, searchedData, savedData, timeValue }: gifMessageProps) {
  let { id, direction, timestamp, fromcaller_details } = Array.isArray(data) && data?.length > 0 ? data[0] : "";
  let isReply = Array.isArray(data) && data?.length > 0 && data[0].message?.isReply ? true : false;
  let linkWdhImg :any = Array.isArray(data) && data?.length > 0 ? data[0].message : "";
  let htimestamp = moment(timestamp).format('hh:mm A');
  let timeCount = timeValue !== undefined ? timeValue : 18;
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const chatSocketMessage = useSelector((state: initialStateModel) => state.chatSocketReducerState);
  const { userdetails }: any = useSelector((state: initialStateModel) => state.loginReducer);
  let { messageList }: any = chatSocketMessage;
  let messageBody = Array.isArray(data) && data?.length > 0 ? data[0].message.body : "";
  const [fileState, setfileState] = useState<fileMessageState>({ isOpen: false, id: "", dataRes: "" });
  const [longText, setlongtext] = useState(0);
  let mstext = messageBody?.text;
  if(mstext && mstext !== ""){
    if (mstext?.length > 760 && longText === 0) {
      mstext = mstext.substring(0, 760) + "...";
    }
  }
  if(messageBody?.mentionID !== '' && messageBody?.mentionID !== undefined ){
    let test = urlifyATmention(messageBody ,mstext)
    mstext = test;
   }
  const handlehighlightHover = () => {
    var element: HTMLElement | any = document.getElementById(id) || null;
    if (element != null) {
      element.classList.add("highlighthover");
    }
  };
  const handleCheckBoxClick = () => {
    if (chatReducer?.isDelete || chatReducer?.isForward) {
      //ChatService.selectedMessageDispatch(data[0]);
    }
  };
  const FilePreviewer = () => {
    setfileState({ ...fileState, isOpen: !fileState.isOpen });
  };
  const handleOnChange = (e: any) => {
    let deletedArray: any = chatReducer.selectMessageData;

    let index = [];
    if (e.target.checked) {
      let arr: any = [...deletedArray, ...multiData]
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: arr
        }
      });
    } else {
      _.forEach(multiData, function (element: any) {
        index = deletedArray.indexOf(element);
        deletedArray.splice(index, 1);
      });

      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: deletedArray
        }
      });
    }

  };
  const openLink = (url: any) => {
    if (!url.includes("http")) url = "https://" + url;
    window.open(url);
  };
  const previewOpenFile = (data:any)=>{
     setfileState({...fileState,isOpen:!fileState.isOpen,id:data?.id,dataRes:data});
   };
   const readMoreChange = ()=>{
    setlongtext(1);
  }
  let isBookmark:any = data[0]?.message?.isSave;
  let widthMulti = (!data[0]?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 ) && data[0]?.message?.isEdit ?"saveEdited": 
  (!data[0]?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 )?"onlySaved": data[0]?.message?.isEdit ? "onlyEdited" : "widthDefault";
 
  return (
    <>
    {fileState.isOpen && (
          <FilePreview
            isOpen={fileState.isOpen}
            data={fileState.dataRes}
            previewopen={FilePreviewer}
            groupdata={messageList}
          />
        )}
      {/* <div className={`${styles.chatMsg} ${styles.leftMessage} ${styles.addBookleftMessage}`}> */}
      {direction === 'IN' ? <div className={`${chatReducer.isSaveChat && id === savedData ? "savedhighlight" : ""} lftMessage ${isReply? styles.chtreplygif: ''} ${styles.chatMsg} ${styles.leftMessage} ${(chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ) ? "checked" : chatReducer?.multiOption?"checking":""}`} id={id}>
      {!isReply && timeCount>15 &&   <div className={`${styles.chatUserDetails}`}>
         <ChatUserInfo userDetails={fromcaller_details} className='userinfoIcon leftSide' />
          <div className={styles.convMemName}> <span>{fromcaller_details?.caller_id}</span></div>
        </div> }
        <div className={styles.chatLeftMessages}>
          <div className={styles.chatLeft}>
            {!isReply && <Tooltip title={htimestamp} className='cusTooltip'
              overlayClassName='customTooltip'><div className={styles.chatTime}>{htimestamp}</div></Tooltip>}
            <div className={isReply ? `msgContentLft ${styles.chatContent} replyGifType` : `msgContentLft ${styles.chatContent}`}>
            {Array.isArray(data) && data[0]?.message?.forward && <ForwardHeader />} 
              <div className={styles.gifContent} onClick={()=>previewOpenFile(Array.isArray(data) && data[0])}>
                {data.map((msgList: any, index: any) => {
                  let messageBody = msgList?.message.body;
                  // console.log(msgList,'Inside File OUT Direction',msgList?.direction);
                  if (msgList?.direction === "IN") {
                    return (
                        <span key={index} className={id === savedData ? "focusText" : ""} tabIndex={0}>
                          <img src={messageBody?.filePath} alt="" />
                        </span>
                     )
                  } else {
                    return null;
                  }
                })}
                <div className={isReply ? `${styles.gifOverIcon} replyOverICon` : styles.gifOverIcon}><img src={gificon} alt="Gif Icon"/></div>
                <div className="mediaBtmGrey">
                  {(messageBody?.text === "" || messageBody?.text === undefined) &&  <ChatGifInfo userDetails={fromcaller_details}
                timeStamp={timestamp} message={Array.isArray(data) && data.length > 0 ? data[0] : []}></ChatGifInfo>
                }</div>
              </div>
              {messageBody?.text &&
                        <div className="textContent">
                        {messageBody?.text && messageBody?.text !== "" &&  <span className={styles.messageContent} >
                        <span  dangerouslySetInnerHTML={{ __html: urlify(mstext) }}></span>
                         {mstext?.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                       </span>}
                         <span className={widthMulti}></span>
                       </div>
                    }
                    { messageBody?.text && messageBody?.text !== "" && <ChatLeftInfo userDetails={fromcaller_details}
                timeStamp={timestamp} message={Array.isArray(data) && data.length > 0 ? data[0] : []}></ChatLeftInfo>}
              {!isReply && Array.isArray(data) && data?.length > 0 && <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                <ChatHoverOption className='hoverList hoverListleft' data={Array.isArray(data) && data?.length > 0 && data[0]} multiFile={multiData} highlightHover={handlehighlightHover} /></div>}
            </div>
          </div>
          {Array.isArray(data) && data?.length > 0 && !isReply && <ChatLike className='likeLeft' placement="topRight"
            tooltipTitle={data[0]?.likeduserdetails} message={data[0]} />}
        </div>
        {!isReply &&(!chatReducer?.isDelete && chatReducer?.multiOption) && Array.isArray(data) && data?.length > 0 &&
          <URCheckBoxCall
            checked={chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ? true : false}
            className="chatSelectRight" onChange={handleOnChange} />}


      </div> :  <div
            className={`${chatReducer.isSaveChat && id === savedData ? "savedhighlight" : ""} rtMessage ${isReply? styles.chtreplygif: ''} ${styles.chatMsg} ${styles.rightMessage
              } 
              ${(chatReducer?.multiOption && chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ) ? "checked" : chatReducer?.multiOption?"checking":""}`}
            onClick={handleCheckBoxClick}
            id={id}
          >
        { timeCount>15 && <div className={`${styles.chatUserDetails}`}>
        <div className={styles.convMemName}><span>You</span></div>
        <ChatUserInfo userDetails={fromcaller_details} className='userinfoIcon rightSide' />
        </div>}
        <div className={styles.chatRightMessages}>
          <div className={styles.chatRight}>
            <div className={isReply ? `msgContentLft ${styles.chatContent} replyGifType` : `msgContentLft ${styles.chatContent}`}>
            {Array.isArray(data) && data[0]?.message?.forward && <ForwardHeader />} 
              <div className={styles.gifContent} onClick={()=>previewOpenFile(Array.isArray(data) && data[0])}>
                {data.map((msgList: any, index: any) => {
                  let messageBody = msgList?.message.body;
                  // console.log(msgList,'Inside File OUT Direction',msgList?.direction);
                  if (msgList?.direction === "OUT") {
                    return (
                        <span key={index} className={id === savedData ? "focusText" : ""} tabIndex={0} >
                          <img src={messageBody?.filePath} alt="" />
                        </span>
                     )
                  } else {
                    return null;
                  }
                })}
                    
      
                <div className="mediaBtmGrey">
                {(messageBody?.text === "" || messageBody?.text === undefined) &&
                  <ChatGifInfo userDetails={fromcaller_details}
                timeStamp={timestamp} message={Array.isArray(data) && data.length > 0 ? data[0] : []}></ChatGifInfo>
              }
                </div>
                
                <div className={isReply ? `${styles.gifOverIcon} replyOverICon` : styles.gifOverIcon}><img src={gificon} alt="Gif Icon"/></div>
              </div>
              
              {messageBody?.text &&
                        <div className="textContent">
                        {messageBody?.text && messageBody?.text !== "" &&  <span className={styles.messageContent} >
                        <span  dangerouslySetInnerHTML={{ __html: urlify(mstext) }}></span>
                         {mstext?.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                       </span>}
                         <span className={widthMulti}></span>
                       </div>
                    }
              {!isReply && Array.isArray(data) && data?.length > 0 && (
                    <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                      <ChatHoverOption
                        className="hoverList hoverListright"
                        data={Array.isArray(data) && data?.length > 0 && data[0]}
                        multiFile={multiData}
                        highlightHover={handlehighlightHover}
                      />
                    </div>
                  )}
              { messageBody?.text && messageBody?.text !== "" &&  <ChatRightInfo userDetails={fromcaller_details}
                timeStamp={timestamp} message={Array.isArray(data) && data.length > 0 ? data[0] : []}></ChatRightInfo>}
              </div>
            {!isReply && <Tooltip placement="topRight" title={htimestamp} className='cusTooltip'
              overlayClassName='customTooltip'><div className={styles.chatTime}>{htimestamp}</div></Tooltip>}
         
          </div>
          
        </div>
        {Array.isArray(data) && data?.length > 0 && !isReply && <ChatLike className='likeRight' placement="topRight"
          tooltipTitle={data[0]?.likeduserdetails} message={data[0]} />}

        {!isReply &&(!chatReducer?.isDelete && chatReducer?.multiOption) && Array.isArray(data) && data?.length > 0 &&
          <URCheckBoxCall
            checked={chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ? true : false}
            className="chatSelectRight" onChange={handleOnChange} />}
      </div>}



    </>
  );
};

